import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayTimeMinute extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayTimeMinute {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDDisplayTimeMinute;

  public mode() {
    return TEDParseDateTimeMode.pdmHM;
  }
}

export { TEDDisplayTimeMinute };
